import { ComponentAlignment, Image, Ratio, Shape, TextAlignment } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const ImageDemo = () => {
  const args = {
    onClick: () => console.log('clicked'),
    withLike: true,
    liked: true,
    likeColor: 'primary-10',
    onLikeClick: () => console.log('like clicked'),
    tag: 'Tag',
    ratio: '16/15' as Ratio,
    cornerRadius: 'medium' as Shape,
    avatarCornerRadius: 'full' as Shape,
    likeIcon: 'favorite',
    borderWidth: '0px',
    borderColor: 'primary-40',
    src: 'https://storage.makyo.me/assets/defaultmap_background.jpg',
    caption:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
    thumb: 'https://storage.makyo.me/assets/sample_avatar_5.jpg',
    thumbAlt: 'Thumbnail',
    captionAlignment: 'left' as TextAlignment,
    tagTypography: 'body-small' as any,
    captionTypography: 'body-small' as any,
    textLineCaption: 2,
    backgroundCaption: 'primary-90',
  }

  return (
    <LayoutDemo title='Image' bgColor='var(--color-primary-90)'>
      <Image
        id='example-image'
        width='100%'
        alignment={'left' as ComponentAlignment}
        margin={{
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
        backgroundColor={'var(--color-primary-70)' as any}
        debug
        {...args}
        captionTypography={{ typography: args.captionTypography } as any}
        tagTypography={{ typography: args.tagTypography } as any}
      />
    </LayoutDemo>
  )
}
